// extracted by mini-css-extract-plugin
export default {"Faq":"Faq-module__Faq--UV6gk"};